export enum Language {
    Css = "css",
    Js = "javascript",
    Json = "json"
}
